export default "__VITE_ASSET__3debea0b__"